import React, {useEffect, useState} from "react";
import styles from "./dateSelectionContainer/DateSelectionContainer.module.scss";
import SwitchKey from "../../../../../Componnets/SwitchKey/SwitchKey";
import Tabs from "../../../../../Componnets/Tabs/Tabs";
import DatePickerTemplate from "./DatePickerTemplate";
import moment from "moment";
import JalaliMoment from "jalali-moment"

const DateSelectionContainer = ({ type, title, handleDone, isTimestamp, value, handleTriggerEnableContainer, isEnableSection }) => {
  const [layout, setLayout] = useState([
    {id: 1, title: "From"},
    {id: 2, title: "To"}
  ]);
  const [activeTab, setActiveTab] = useState({rangeSelection: true});
  const [callApi, setCallApi] = useState(true);
  const [firstTimeLoad, setFirstTimeLoad] = useState(true);
  const [whichDropdownIsOpen, setWhichDropdownIsOpen] = useState(-1);

  const [from, setFrom] = useState({
    dateToPass: null,
    dateToShow: null,
    timeToShow: null,
  })
  const [to, setTo] = useState({
    dateToPass: null,
    dateToShow: null,
    timeToShow: null,
  });

  useEffect(() => {console.log('isEnableSection',isEnableSection)},[isEnableSection])
  useEffect(() => {console.log('handleTriggerEnableContainer',handleTriggerEnableContainer)},[handleTriggerEnableContainer])

  useEffect(() => {
    if (!Array.isArray(value) || !value[0]) return;

    const arr = value[0].split(",");
    if (!arr[0]) return;

    if (arr[1]) {
      const start =
          process.env.REACT_APP_CALENDAR_TYPE === "persian"
              ? JalaliMoment(arr[0], "jYYYY-jMM-jDD HH:mm:ss")
              : moment(arr[0]);

      const end =
          process.env.REACT_APP_CALENDAR_TYPE === "persian"
              ? JalaliMoment(arr[1])
              : moment(arr[1]);

      if (start.isValid() && end.isValid()) {
        if (moment.duration(end.diff(start)).asHours() > 24) {
          setActiveTab({ rangeSelection: true });
        }
      }
    } else {
      setActiveTab({ rangeSelection: true });
    }

    setFirstTimeLoad(false);
  }, [value]);


  const handleSetDate = (type, dateToPass, dateToShow, timeToShow, callApi) => {
    const formattedDate = moment(dateToPass).format("YYYY-MM-DD HH:mm:ss");
    setCallApi(callApi);
    switch (type) {
      case "From":
        setFrom({dateToPass: dateToPass ? formattedDate : null, dateToShow, timeToShow });
        break;
      case "To":
        setTo({dateToPass: dateToPass ? formattedDate : null, dateToShow, timeToShow});
        break;
      default:
        break;
    }
  }

  let column = ["STARTTIME"];
  if (isTimestamp) {
    column = ["TIMESTAMP"];
  } else {
    if (type === "startDate") {
      column = ["STARTTIME"];
    } else {
      column = ["ENDTIME"];
    }
  }

  useEffect(() => {
    // console.log(
    //     "moment valid:",
    //     moment(from.dateToPass).isValid()
    // );
    //
    // console.log(
    //     "jalali valid:",
    //     JalaliMoment(
    //         from.dateToPass,
    //         "jYYYY-jMM-jDD HH:mm:ss"
    //     ).isValid()
    // );
    let toDate = to.dateToPass && to.dateToPass.toString();
    let toDateObject = to
    if (to && (to.timeToShow === "00:00")) {
      const newDate = moment(to.dateToPass).set({ hour: 23, minute: 59, second: 59 }).format("YYYY-MM-DD HH:mm:ss");
      toDate = newDate.toString();
      toDateObject = {
        ...to,
        dateToPass: newDate,
        timeToShow: "23:59"
      }
      setTo(toDateObject)
    }
    if (callApi) {
      if (activeTab["preciseDate"]) {
        handleDone({
          dateToPass: [
            {
              column,
              operand: ["between"],
              value: from.dateToPass ? [[from.dateToPass.toString(), moment(from.dateToPass).set({ hour: 23, minute: 59, second: 59 }).format().toString()].join(",")] : null,
              is_active: true,
            }
          ],
        }, type)
      } else {
        handleDone({
          dateToPass: [
            {
              column,
              // operand: (from.dateToPass && to.dateToPass) ? ["between"] : [">="],
              operand: ["between"],
              value: (from.dateToPass || to.dateToPass) &&
                [[from.dateToPass ? from.dateToPass.toString() : moment().set({ hour: 0, minute: 0, second: 0 }).format("YYYY-MM-DD HH:mm:ss"), toDateObject && toDateObject.dateToPass ? toDateObject.dateToPass.toString() : moment().set({ hour: 23, minute: 59, second: 59 }).format("YYYY-MM-DD HH:mm:ss")].join(",")],
              is_active: true,
            }
          ],
        }, type)
        setCallApi(false)
      }
    }
  }, [from, to, callApi]);


  const parseJalaliDate = (date, endOfDay = false) => {
    if (!date) return null;

    const OUTPUT_FORMAT = "jYYYY-jMM-jDD HH:mm:ss";

    const formats = [
      "jYYYY-jMM-jDD HH:mm:ss",
      "jYYYY-jMM-jDD HH:mm",
      "jYYYY-jMM-jDD",
      "jYYYY/jMM/jDD HH:mm:ss",
      "jYYYY/jMM/jDD HH:mm",
      "jYYYY/jMM/jDD"
    ];

    const dateString = String(date).trim();

    let parsed = null;

    for (const f of formats) {
      const m = JalaliMoment(dateString, f, true);
      if (m && m.isValid()) {
        parsed = m;
        break;
      }
    }

    if (!parsed) {
      console.warn("Invalid jalali date:", dateString);
      return null;
    }

    if (endOfDay) {
      parsed.set({ hour: 23, minute: 59, second: 59, millisecond: 0 });
    } else {
      parsed.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    }

    return parsed.format(OUTPUT_FORMAT);
  };


  // useEffect(() => {
  //   if (!callApi) return;
  //
  //   const OUTPUT_FORMAT = "jYYYY-jMM-jDD HH:mm:ss";
  //
  //   const formats = [
  //     "jYYYY-jMM-jDD HH:mm:ss",
  //     "jYYYY-jMM-jDD HH:mm",
  //     "jYYYY-jMM-jDD",
  //     "jYYYY/jMM/jDD HH:mm:ss",
  //     "jYYYY/jMM/jDD HH:mm",
  //     "jYYYY/jMM/jDD",
  //   ];
  //
  //   const parseJalaliDate = (date, endOfDay = false) => {
  //     if (!date) return null;
  //
  //     // اگر moment object باشد
  //     if (typeof date === "object" && date._isAMomentObject) {
  //       const m = JalaliMoment(date);
  //       if (!m.isValid()) return null;
  //
  //       m.set(
  //           endOfDay
  //               ? { hour: 23, minute: 59, second: 59, millisecond: 0 }
  //               : { hour: 0, minute: 0, second: 0, millisecond: 0 }
  //       );
  //
  //       return m.format(OUTPUT_FORMAT);
  //     }
  //
  //     const dateString = String(date).trim();
  //
  //     let parsed = null;
  //
  //     for (const f of formats) {
  //       const m = JalaliMoment(dateString, f, true);
  //       if (m && m.isValid()) {
  //         parsed = m;
  //         break;
  //       }
  //     }
  //
  //     if (!parsed) {
  //       console.warn("Invalid jalali date:", dateString);
  //       return null;
  //     }
  //
  //     parsed.set(
  //         endOfDay
  //             ? { hour: 23, minute: 59, second: 59, millisecond: 0 }
  //             : { hour: 0, minute: 0, second: 0, millisecond: 0 }
  //     );
  //
  //     return parsed.format(OUTPUT_FORMAT);
  //   };
  //
  //   // ✅ normalize without changing state
  //   const normalizedFrom = parseJalaliDate(from?.dateToPass, false);
  //   const normalizedTo = parseJalaliDate(to?.dateToPass, true);
  //
  //   // fallback اگر خالی بود
  //   const finalFrom =
  //       normalizedFrom ||
  //       JalaliMoment()
  //           .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
  //           .format(OUTPUT_FORMAT);
  //
  //   const finalTo =
  //       normalizedTo ||
  //       JalaliMoment()
  //           .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
  //           .format(OUTPUT_FORMAT);
  //
  //   // اگر preciseDate فعال باشد
  //   let sendFrom = finalFrom;
  //   let sendTo = finalTo;
  //
  //   if (activeTab?.preciseDate && from?.dateToPass) {
  //     const preciseTo = parseJalaliDate(from.dateToPass, true);
  //     if (preciseTo) {
  //       sendTo = preciseTo;
  //     }
  //   }
  //
  //   handleDone(
  //       {
  //         dateToPass: [
  //           {
  //             column,
  //             operand: ["between"],
  //             value: [[sendFrom, sendTo].join(",")],
  //             is_active: true,
  //           },
  //         ],
  //       },
  //       type
  //   );
  //
  //   setCallApi(false);
  //
  // }, [from, to, callApi]);



  const tabsList = [
    {
      title: "Range Selection",
      id: "rangeSelection",
      icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.06485 7.39932H16.9352M7.39932 7.83276L7.39932 16.9352M2.79406 12.5413C2.40198 10.8698 2.40198 9.13021 2.79406 7.45869C3.33698 5.14417 5.14417 3.33698 7.45869 2.79406C9.13021 2.40198 10.8698 2.40198 12.5413 2.79406C14.8558 3.33698 16.663 5.14417 17.2059 7.4587C17.598 9.13021 17.598 10.8698 17.2059 12.5413C16.663 14.8558 14.8558 16.663 12.5413 17.2059C10.8698 17.598 9.13021 17.598 7.4587 17.2059C5.14418 16.663 3.33698 14.8558 2.79406 12.5413Z" stroke="#70789E" stroke-width="1.5"/>
      </svg>,
    },
    {
      title: "Precise Date",
      id: "preciseDate",
      icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.18859 10.2235C5.88701 8.93782 5.88701 7.59978 6.18859 6.31409C6.60618 4.53383 7.99623 3.14378 9.7765 2.72619C11.0622 2.4246 12.4002 2.4246 13.6859 2.72619C15.4662 3.14378 16.8562 4.53383 17.2738 6.3141C17.5754 7.59978 17.5754 8.93782 17.2738 10.2235C16.8562 12.0038 15.4662 13.3938 13.6859 13.8114C12.4002 14.113 11.0622 14.113 9.7765 13.8114M6.18859 10.2235C6.60618 12.0038 7.99623 13.3938 9.7765 13.8114M6.18859 10.2235C5.9987 9.41398 5.92837 8.58371 5.97761 7.75881C5.90798 7.77302 5.83852 7.78825 5.76922 7.8045C4.24328 8.16244 3.05181 9.35391 2.69387 10.8799C2.43538 11.9819 2.43538 13.1288 2.69387 14.2308C3.05181 15.7567 4.24328 16.9482 5.76922 17.3061C6.87124 17.5646 8.01813 17.5646 9.12014 17.3061C10.6461 16.9482 11.8376 15.7567 12.1955 14.2308C12.2117 14.1615 12.227 14.092 12.2412 14.0224C11.4163 14.0716 10.586 14.0013 9.7765 13.8114" stroke="#C2C7ED" stroke-width="1.5"/>
      </svg>,
    }
  ];

  const datePickersInfo = [
    {
      id: 1,
      title: "From"
    },
    {
      id: 2,
      title: "To"
    }
  ]

  const handleTriggerSwitchKey = () => {
    handleTriggerEnableContainer(type);
  }

  const handleActiveTab = (tab) => {
    setActiveTab(tab);
    if (!firstTimeLoad) {
      setTimeout(() => {
        handleDone({
          dateToPass: [
            {
              column,
              operand: ["between"],
              value: [],
              is_active: true,
            }
          ],
        })
      }, 1);
    }

    if (tab["preciseDate"]) {
      setLayout([datePickersInfo[0]]);
    } else {
      setLayout(datePickersInfo);
    }
  }

  return (
    <div className={`${styles.DateSelectionContainer}`}>
      <div className={`${styles.dateSelectionHeader} d-flex justify-content-between`}>
        <div className={'d-flex'}>
          { title }
        </div>
        <div className={'d-flex'}>
          <SwitchKey active={isEnableSection} handleOnChange={handleTriggerSwitchKey} />
        </div>
      </div>
      {
        isEnableSection
          ? (
            <>
            <div className={'mt-3'}>
              <Tabs
                tabsList={tabsList}
                handleActiveTab={handleActiveTab}
                active={activeTab}
              />
            </div>
            <div className={`mt-4 d-flex ${styles.dropdown}`}>
              {
                layout.map((item, index) => {
                  // A saved date filter contains its range as one `from,to` string.
                  // Split it before hydrating the individual date pickers; passing
                  // the complete range to each picker makes it an invalid date and
                  // clears the editor when the filter is opened again.
                  const savedRange = Array.isArray(value) && typeof value[0] === "string"
                    ? value[0].split(",")
                    : [];
                  const val = savedRange[index] || null;

                  // Detect the source calendar from the literal year. Parsing a
                  // Jalali value such as 1404 as Gregorian before this check and
                  // converting it again produces dates hundreds of years earlier.
                  const parsedYear = typeof val === "string"
                    ? Number(val.trim().match(/^(\d{4})/)?.[1])
                    : NaN;
                  const isFa = parsedYear >= 1200 && parsedYear <= 1600;

                  let formattedValue = null;

                  if (value && value[0]) {
                    if (
                        process.env.REACT_APP_CALENDAR_TYPE === "persian" &&
                        !isFa &&
                        val &&
                        JalaliMoment(val).isValid()
                    ) {
                      formattedValue = JalaliMoment(val).format("jYYYY-jMM-jDD HH:mm:ss");
                    } else {
                      formattedValue = val;
                    }
                  }
                  return (
                    <div style={{width: `calc(${100 / layout.length}%)`}}>
                      <DatePickerTemplate
                        type={(layout.length > 1 || type === "startDate") ? item.title : "To"}
                        isOpen={whichDropdownIsOpen === index}
                        key={index}
                        whichDropdownIsOpen={() => {
                          if (index === whichDropdownIsOpen) {
                            setWhichDropdownIsOpen(-1);
                          } else {
                            setWhichDropdownIsOpen(index);
                          }
                        }}
                        dropdownOpenPosition={index === 0 ? 'left' : 'right'}
                        columnLayout={layout.length > 1}
                        handleSetPassedDate={(pureDate, dateToShow, timeToShow, callApi) => handleSetDate(item.title, pureDate, dateToShow, timeToShow, callApi)}
                        value={formattedValue}
                      />
                    </div>
                  )
                })
              }
            </div>
            {
              layout.length > 1 ?
                (
                  value && value[0] && from && to ?
                    (
                      <p>
                        This End Date Selection filter will show cases which they’ve ended exactly between “{ from.dateToShow || "-" } on { from.timeToShow || "-" } ” and “{ to.dateToShow || "-" } on { to.timeToShow || "-" }”
                      </p>
                    )
                    : (
                      type === "startDate" ?
                        <p>
                          Select a date range from presets or on calendar by clicking the “From” and “To” dropdown
                        </p> :
                        <p>
                          Select a date range to presets or on calendar by clicking the “From” and “To” dropdown
                        </p>
                    )
                )
                : (
                  from.dateToShow ?
                    (
                      type === "startDate" ?
                      <p>
                        This Start Date Selection filter will show cases which they’ve started exactly on { from.dateToShow || "-" } at the time { from.timeToShow || "-" }
                      </p> :
                      <p>
                        This End Date Selection filter will show cases which they’ve started exactly on { from.dateToShow || "-" } at the time { from.timeToShow || "-" }
                      </p>
                    )
                    : (
                      type === "startDate" ?
                        <p>
                          Select a date on calendar by clicking the “From” dropdown
                        </p> :
                        <p>
                          Select a date on calendar by clicking the “To” dropdown
                        </p>
                    )

                )
            }
            {
              type === "startDate" && ((activeTab["preciseDate"] && from.dateToPass) || (activeTab["rangeSelection"] && from.dateToPass && to.dateToPass)) &&
                <>
                  <div className={`${styles.horizontalChart} ${activeTab["preciseDate"] ? styles.preciseDate : styles.rangeDate} ${styles.startDate} d-flex align-items-center justify-content-between`}>
                    <div className={styles.caseTimeline}>
                      Case Timeline
                    </div>
                    <div>
                      <div className={styles.nums}>
                        <span className={activeTab["rangeSelection"] && styles.selected}>{moment(from.dateToPass).subtract(activeTab["preciseDate"] ? 1 : 0, "days").format("DD")}</span>
                        <span className={styles.selected}>
                          {
                            activeTab["preciseDate"] ?
                             moment(from.dateToPass).format("DD") : "..."
                          }
                        </span>
                        <span className={activeTab["rangeSelection"] && styles.selected}>{moment(activeTab["preciseDate"] ? from.dateToPass : (to.dateToPass ? to.dateToPass : from.dateToPass)).add(activeTab["preciseDate"] ? 1 : 0, "days").format("DD")}</span>
                        <span>{moment(activeTab["preciseDate"] ? from.dateToPass : (to.dateToPass ? to.dateToPass : from.dateToPass)).add(activeTab["preciseDate"] ? 2 : 1, "days").format("DD")}</span>
                      </div>
                      <div>
                        <svg width="296" height="1" viewBox="0 0 296 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <line x1="237" y1="0.5" y2="0.5" stroke="#C2C7ED"/>
                          <line x1="239" y1="0.5" x2="296" y2="0.500005" stroke="#C2C7ED" stroke-dasharray="5 5"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.arrow} ${styles.from} ${activeTab["preciseDate"] ? styles.preciseDate : styles.rangeDate} d-flex justify-content-between align-items-end`}>
                    <div className={'mr-2'}>
                      <svg width="21" height="32" viewBox="0 0 21 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.22226 12.8438L2.45957 12.9224L2.22226 12.8438ZM6.36962 0.887878C6.30765 0.764495 6.15739 0.714713 6.03401 0.776683L4.02338 1.78657C3.9 1.84855 3.85022 1.99881 3.91219 2.12219C3.97416 2.24557 4.12442 2.29535 4.2478 2.23338L6.03502 1.3357L6.93271 3.12292C6.99468 3.24631 7.14494 3.29609 7.26832 3.23411C7.3917 3.17215 7.44148 3.02188 7.37951 2.8985L6.36962 0.887878ZM20.4132 30.2655C19.5747 30.5759 18.7378 30.8009 17.909 30.947L17.9958 31.4394C18.8545 31.2881 19.7204 31.0551 20.5868 30.7345L20.4132 30.2655ZM16.8817 31.0885C15.102 31.2656 13.3703 31.0848 11.7516 30.6096L11.6108 31.0893C13.2894 31.5822 15.0857 31.7697 16.9312 31.5861L16.8817 31.0885ZM10.7685 30.2798C9.13972 29.6637 7.64684 28.7443 6.36373 27.5922L6.02967 27.9642C7.35765 29.1566 8.90354 30.1089 10.5917 30.7474L10.7685 30.2798ZM5.61722 26.871C4.42142 25.6285 3.45092 24.1683 2.77887 22.5618L2.3176 22.7547C3.01412 24.4198 4.01935 25.9318 5.25696 27.2177L5.61722 26.871ZM2.41528 21.5907C1.88435 19.9895 1.64378 18.265 1.7592 16.4803L1.26024 16.448C1.14055 18.2987 1.39009 20.0875 1.94069 21.748L2.41528 21.5907ZM1.86514 15.4487C1.98247 14.6153 2.17838 13.7711 2.45957 12.9224L1.98495 12.7651C1.6944 13.6421 1.49158 14.5155 1.37003 15.379L1.86514 15.4487ZM2.45957 12.9224L3.27706 10.455L2.80244 10.2977L1.98495 12.7651L2.45957 12.9224ZM3.60406 9.46799L5.23904 4.53312L4.76442 4.37587L3.12943 9.31074L3.60406 9.46799ZM5.56604 3.54615L6.38353 1.07871L5.9089 0.921462L5.09141 3.3889L5.56604 3.54615ZM2.22226 12.8438L2.69689 13.001L2.22226 12.8438ZM6.59302 0.775669C6.46908 0.528903 6.16856 0.429336 5.9218 0.553283L1.90054 2.57307C1.65378 2.69701 1.55421 2.99753 1.67816 3.24429C1.8021 3.49105 2.10262 3.59062 2.34938 3.46668L5.92383 1.67131L7.71919 5.24576C7.84314 5.49253 8.14366 5.59209 8.39042 5.46815C8.63719 5.3442 8.73675 5.04369 8.61281 4.79692L6.59302 0.775669ZM20.3264 30.0311C19.5019 30.3363 18.6795 30.5573 17.8656 30.7008L18.0392 31.6856C18.9128 31.5316 19.7932 31.2948 20.6736 30.9689L20.3264 30.0311ZM16.8569 30.8398C15.1101 31.0136 13.4107 30.8361 11.8221 30.3697L11.5404 31.3292C13.2489 31.8308 15.0776 32.0217 16.9559 31.8349L16.8569 30.8398ZM10.857 30.046C9.2578 29.4411 7.79143 28.5381 6.53075 27.4061L5.86265 28.1502C7.21306 29.3627 8.78545 30.3315 10.5032 30.9813L10.857 30.046ZM5.79735 26.6977C4.62246 25.4769 3.66932 24.0426 3.0095 22.4653L2.08697 22.8512C2.79571 24.5455 3.81831 26.0834 5.07683 27.3911L5.79735 26.6977ZM2.65258 21.512C2.13149 19.9405 1.89539 18.2482 2.00868 16.4964L1.01076 16.4319C0.888941 18.3156 1.14296 20.1365 1.70339 21.8267L2.65258 21.512ZM2.1127 15.4835C2.22791 14.6651 2.42037 13.8356 2.69689 13.001L1.74763 12.6865C1.45241 13.5776 1.24613 14.4657 1.12247 15.3441L2.1127 15.4835ZM2.69689 13.001L3.51438 10.5336L2.56512 10.2191L1.74763 12.6865L2.69689 13.001ZM3.84138 9.54662L5.47636 4.61174L4.5271 4.29724L2.89212 9.23211L3.84138 9.54662ZM5.80336 3.62477L6.62085 1.15734L5.67159 0.842838L4.8541 3.31027L5.80336 3.62477Z" fill="#C2C7ED"/>
                      </svg>
                    </div>
                    {
                      activeTab["preciseDate"] &&
                        <div>
                          Cases <span>Started</span> on {from.dateToShow}
                        </div>
                    }
                    {
                      activeTab["rangeSelection"] &&
                        <div>
                          Cases <span>Started</span> Between {from.dateToShow} to {to.dateToShow}
                        </div>
                    }
                  </div>
                </>
            }
            {
              type === "endDate" && ((activeTab["preciseDate"] && from.dateToPass) || (activeTab["rangeSelection"] && from.dateToPass && to.dateToPass)) &&
                <>
                  <div className={`${styles.horizontalChart} ${activeTab["preciseDate"] ? styles.preciseDate : styles.rangeDate} ${styles.endDate} d-flex align-items-center justify-content-between`}>
                    <div>
                      <div className={styles.nums}>
                        <span className={activeTab["rangeSelection"] && styles.selected}>{moment(from.dateToPass).subtract(activeTab["preciseDate"] ? 2 : 2, "days").format("DD")}</span>
                        <span className={activeTab["rangeSelection"] && styles.selected}>{moment(from.dateToPass).subtract(activeTab["preciseDate"] ? 1 : 0, "days").format("DD")}</span>
                        <span className={styles.selected}>
                          {
                            activeTab["preciseDate"] ?
                              moment(from.dateToPass).format("DD") : "..."
                          }
                        </span>
                        <span className={activeTab["rangeSelection"] && styles.selected}>{moment(activeTab["preciseDate"] ? from.dateToPass : (to.dateToPass ? to.dateToPass : from.dateToPass)).add(activeTab["preciseDate"] ? 1 : 0, "days").format("DD")}</span>
                        {/*<span>{moment(activeTab["preciseDate"] ? date.from.dateToPass : date.to.dateToPass).add(activeTab["preciseDate"] ? 2 : 1, "days").format("DD")}</span>*/}
                      </div>
                      <div>
                        <svg width="296" height="1" viewBox="0 0 296 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <line x1="296" y1="0.5" x2="50" y2="0.499978" stroke="#C2C7ED"/>
                          <line x1="4.37114e-08" y1="0.5" x2="57" y2="0.500005" stroke="#C2C7ED" stroke-dasharray="5 5"/>
                        </svg>
                      </div>
                    </div>
                    <div className={`${styles.caseTimeline}`}>
                      Case Timeline
                    </div>
                  </div>
                  <div className={`${styles.arrow} ${activeTab["preciseDate"] && styles.preciseDate} ${styles.to} d-flex justify-content-between align-items-end`}>
                    <div className={'mr-2'}>
                      <svg width="21" height="32" viewBox="0 0 21 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.22226 12.8438L2.45957 12.9224L2.22226 12.8438ZM6.36962 0.887878C6.30765 0.764495 6.15739 0.714713 6.03401 0.776683L4.02338 1.78657C3.9 1.84855 3.85022 1.99881 3.91219 2.12219C3.97416 2.24557 4.12442 2.29535 4.2478 2.23338L6.03502 1.3357L6.93271 3.12292C6.99468 3.24631 7.14494 3.29609 7.26832 3.23411C7.3917 3.17215 7.44148 3.02188 7.37951 2.8985L6.36962 0.887878ZM20.4132 30.2655C19.5747 30.5759 18.7378 30.8009 17.909 30.947L17.9958 31.4394C18.8545 31.2881 19.7204 31.0551 20.5868 30.7345L20.4132 30.2655ZM16.8817 31.0885C15.102 31.2656 13.3703 31.0848 11.7516 30.6096L11.6108 31.0893C13.2894 31.5822 15.0857 31.7697 16.9312 31.5861L16.8817 31.0885ZM10.7685 30.2798C9.13972 29.6637 7.64684 28.7443 6.36373 27.5922L6.02967 27.9642C7.35765 29.1566 8.90354 30.1089 10.5917 30.7474L10.7685 30.2798ZM5.61722 26.871C4.42142 25.6285 3.45092 24.1683 2.77887 22.5618L2.3176 22.7547C3.01412 24.4198 4.01935 25.9318 5.25696 27.2177L5.61722 26.871ZM2.41528 21.5907C1.88435 19.9895 1.64378 18.265 1.7592 16.4803L1.26024 16.448C1.14055 18.2987 1.39009 20.0875 1.94069 21.748L2.41528 21.5907ZM1.86514 15.4487C1.98247 14.6153 2.17838 13.7711 2.45957 12.9224L1.98495 12.7651C1.6944 13.6421 1.49158 14.5155 1.37003 15.379L1.86514 15.4487ZM2.45957 12.9224L3.27706 10.455L2.80244 10.2977L1.98495 12.7651L2.45957 12.9224ZM3.60406 9.46799L5.23904 4.53312L4.76442 4.37587L3.12943 9.31074L3.60406 9.46799ZM5.56604 3.54615L6.38353 1.07871L5.9089 0.921462L5.09141 3.3889L5.56604 3.54615ZM2.22226 12.8438L2.69689 13.001L2.22226 12.8438ZM6.59302 0.775669C6.46908 0.528903 6.16856 0.429336 5.9218 0.553283L1.90054 2.57307C1.65378 2.69701 1.55421 2.99753 1.67816 3.24429C1.8021 3.49105 2.10262 3.59062 2.34938 3.46668L5.92383 1.67131L7.71919 5.24576C7.84314 5.49253 8.14366 5.59209 8.39042 5.46815C8.63719 5.3442 8.73675 5.04369 8.61281 4.79692L6.59302 0.775669ZM20.3264 30.0311C19.5019 30.3363 18.6795 30.5573 17.8656 30.7008L18.0392 31.6856C18.9128 31.5316 19.7932 31.2948 20.6736 30.9689L20.3264 30.0311ZM16.8569 30.8398C15.1101 31.0136 13.4107 30.8361 11.8221 30.3697L11.5404 31.3292C13.2489 31.8308 15.0776 32.0217 16.9559 31.8349L16.8569 30.8398ZM10.857 30.046C9.2578 29.4411 7.79143 28.5381 6.53075 27.4061L5.86265 28.1502C7.21306 29.3627 8.78545 30.3315 10.5032 30.9813L10.857 30.046ZM5.79735 26.6977C4.62246 25.4769 3.66932 24.0426 3.0095 22.4653L2.08697 22.8512C2.79571 24.5455 3.81831 26.0834 5.07683 27.3911L5.79735 26.6977ZM2.65258 21.512C2.13149 19.9405 1.89539 18.2482 2.00868 16.4964L1.01076 16.4319C0.888941 18.3156 1.14296 20.1365 1.70339 21.8267L2.65258 21.512ZM2.1127 15.4835C2.22791 14.6651 2.42037 13.8356 2.69689 13.001L1.74763 12.6865C1.45241 13.5776 1.24613 14.4657 1.12247 15.3441L2.1127 15.4835ZM2.69689 13.001L3.51438 10.5336L2.56512 10.2191L1.74763 12.6865L2.69689 13.001ZM3.84138 9.54662L5.47636 4.61174L4.5271 4.29724L2.89212 9.23211L3.84138 9.54662ZM5.80336 3.62477L6.62085 1.15734L5.67159 0.842838L4.8541 3.31027L5.80336 3.62477Z" fill="#C2C7ED"/>
                      </svg>
                    </div>
                    {
                      activeTab["preciseDate"] &&
                        <div>
                          Cases <span>Ended</span> on {from.dateToShow}
                        </div>
                    }
                    {
                      activeTab["rangeSelection"] &&
                        <div>
                          Cases <span>Ended</span> Between {from.dateToShow} to {to.dateToShow}
                        </div>
                    }
                  </div>
                </>
            }
          </>
          )
          : (
            <div className={styles.disableSectionText}>
              {
                type === "startDate" &&
                <p>
                  You can filter cases by their start time. With this filter you can select a precise date or a range for the start time.
                </p>
              }
              {
                type === "endDate" &&
                  <>
                    <p>
                      You can filter cases by their end time. With this filter you can select a precise date or a range for the end time.
                    </p>
                  </>
              }
            </div>
          )
      }
    </div>
  )
}

export default DateSelectionContainer;
